import type { FsPlan } from ':/_types/datafiles.ts'

export const plans = {
  community: {
    slug: 'community',
    name: 'Community',
    color: 'coral',
    virus_scanning: true,
    ai_features: true,
    distributed_video_transcoding: true,
    overage: false,
    price_period: ' ',
    gb_period: '/mo',
    price: 'Free',
    priority_job_slots: 200,
    seats: 1,
    support: 'bronze',
    file_size_limit_in_gb: 0.5,
    included_gb: 5,
  } satisfies FsPlan,
  hobbyist: {
    slug: 'hobbyist-nov-2024',
    name: 'Startup',
    color: 'orange',
    virus_scanning: true,
    ai_features: true,
    distributed_video_transcoding: true,
    overage: false,
    price_period: '/mo',
    gb_period: '/mo',
    price: '$9',
    priority_job_slots: 200,
    seats: 2,
    support: 'bronze',
    file_size_limit_in_gb: 0.5,
    included_gb: 5,
  } satisfies FsPlan,
  startup: {
    slug: 'startup-nov-2024',
    name: 'Startup',
    color: 'green',
    virus_scanning: true,
    ai_features: true,
    distributed_video_transcoding: true,
    overage: '$1.80',
    price_period: '/mo',
    gb_period: '/mo',
    price: '$69',
    priority_job_slots: 300,
    seats: 2,
    support: 'bronze',
    file_size_limit_in_gb: 5,
    included_gb: 40,
  } satisfies FsPlan,
  'small-business': {
    slug: 'small-business-nov-2024',
    name: 'Small Business',
    color: 'blue',
    virus_scanning: true,
    ai_features: true,
    distributed_video_transcoding: true,
    overage: '$1.50',
    price_period: '/mo',
    gb_period: '/mo',
    price: '$139',
    priority_job_slots: 900,
    seats: 5,
    file_size_limit_in_gb: 10,
    support: 'bronze',
    included_gb: 100,
  } satisfies FsPlan,
  'medium-business': {
    slug: 'medium-business-nov-2024',
    name: 'Medium Business',
    color: 'purple',
    virus_scanning: true,
    ai_features: true,
    distributed_video_transcoding: true,
    overage: '$1.20',
    price_period: '/mo',
    gb_period: '/mo',
    price: '$349',
    priority_job_slots: 3000,
    seats: 10,
    file_size_limit_in_gb: 20,
    support: 'gold',
    included_gb: 300,
  } satisfies FsPlan,
  custom: {
    slug: 'enterprise',
    name: 'Custom',
    color: 'blue',
    virus_scanning: true,
    ai_features: true,
    distributed_video_transcoding: true,
    overage: '$0.90',
    price_period: '/custom',
    gb_period: '/custom',
    price: '$499',
    priority_job_slots: 2500,
    seats: -1,
    file_size_limit_in_gb: 200,
    support: 'diamond',
    included_gb: 500,
  } satisfies FsPlan,
}
